import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSwiftlaneMatchingUsersRequest = {
  userEmail: string
  buildingId: number
}

export type SwiftlaneUser = {
  id: string
  name?: string
  email?: string
}

const getSwiftlaneMatchingUsers = async (data: GetSwiftlaneMatchingUsersRequest) => {
  const response = await authAPI.post<SwiftlaneUser[]>(
    `/swiftlane/users/matching/${data.buildingId}`,
    { userEmail: data.userEmail },
  )
  return response.data
}

export const useGetSwiftlaneMatchingUsers = () =>
  useMutation({
    mutationFn: getSwiftlaneMatchingUsers,
  })
